import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Drawer as AntdDrawer,
  Flex,
  Card,
  Avatar,
  Button,
  Row,
  Col,
  Typography,
  List,
} from "antd";
import Title from "antd/es/typography/Title";
import { CloseOutlined } from "@ant-design/icons";
import { toastService } from "../toast-messages/toast";
import { routes, userRoles } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../constants/colors";
import { useTranslation } from "react-i18next";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { useDrawerMenuUtils } from "../../../utils/useDrawerMenuUtils";
import { RightOutlined, CopyOutlined } from "@ant-design/icons";
import {
  BankDetailsIcon,
  PaymentsIcon,
  SettingsIcon,
} from "../../../assets/svg";
import { appConfig } from "../../../constants/config/appConfig";
import { appAssetsConfig } from "../../../constants/config/appAssetsConfig";
import LanguagePickerDialog from "../language-picker-dialog/LanguagePickerDialog";
import { LanguageContext } from "../../../context/LanguageProvider";
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import { UserOutlined } from "@ant-design/icons";
import PaymentMethodDialog from "../payment-method-dialog/PaymentMethodDialog";
import { preferredLanguageApi } from "../../../redux/services/language/languageServices";

const Drawer = ({ drawerOpen, setDrawerOpen }) => {
  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  const copyReferCodeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const { loginDetails } = useSelector((state) => state.auth);

  /* i18n dependencies */
  const { t } = useTranslation();
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);
  /* i18n dependencies */

  const [placement, setPlacement] = useState("left");

  /* profile menu dependencies */
  const menuGroup = useDrawerMenuUtils(t);
  /* profile menu dependencies */

  /* local storage dependencies */
  const { userSession, removeUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  /* local storage dependencies */

  /* dialog dependencies */
  const [openLanguagePickerDialog, setOpenLanguagePickerDialog] =
    useState(false);
  /* dialog dependencies */

  /* dialog dependencies */
  const [openPaymentMethodDialog, setPaymentMethodDialog] = useState(false);
  /* dialog dependencies */

  /* card data dependencies */
  const cardData = [
    {
      icon: PaymentsIcon,
      title: t("Payments"),
      path: "",
    },
    {
      icon: BankDetailsIcon,
      title: t("BankDetails"),
      path: baseRouteMaker(routes.UPDATE_BANK_ACCOUNT),
    },
    {
      icon: CopyOutlined,
      title: t("ProfileMenuNames.CopyReferCode"),
      path: "",
    },
  ];
  /* card data dependencies */

  /* on drawer menu clicked */
  const handleDrawerMenuClick = (event, item) => {
    if (item?.label === t("ProfileMenuNames.Languages")) {
      setOpenLanguagePickerDialog(true);
    }
    if (item?.path === baseRouteMaker(routes.SIGN_IN)) {
      // const dataToBeSent = {
      //   preferred_language: "en",
      // }
      // dispatch(preferredLanguageApi(dataToBeSent, setLoading)).then(()=>{
      // })
      removeUserSession();
      toastService.success(t("logout.logoutProviderText"));
    }
    item?.path && navigate(item?.path);
  };
  /* on drawer menu clicked */

  useEffect(() => {
    let position = "left";
    if (selectedLanguage?.dir === "ltr") {
      position = "right";
    }
    setPlacement(position);
  }, [selectedLanguage?.dir]);

  const GetClipBoardLayout = ({ children, isClipBoard }) => {
    return (
      <>
        {isClipBoard ? (
          <CopyToClipboard
            text={loginDetails?.unique_refer_code}
            onCopy={() => toastService.success("Refer code copied!")}
          >
            {children}
          </CopyToClipboard>
        ) : (
          <>{children}</>
        )}
      </>
    );
  };

  return (
    <>
      <AntdDrawer
        width={445}
        placement={placement}
        open={drawerOpen}
        onClose={() => setDrawerOpen(!drawerOpen)}
        closeIcon={false}
      >
        <Flex vertical gap="2rem">
          <Flex justify="space-between">
            <Flex gap="0.5rem" align="center">
              <Avatar
                src={userSession?.profileImage}
                size={55}
                shape="square"
                icon={<UserOutlined />}
              />
              <Flex vertical>
                <Title level={2}>{userSession?.userName}</Title>
                <Title level={4} type="secondary" style={{ margin: 0 }}>
                  {userSession?.userEmail}
                </Title>
              </Flex>
            </Flex>
            <Button
              size="small"
              onClick={() => setDrawerOpen((prevValue) => !prevValue)}
              icon={<CloseOutlined />}
            />
          </Flex>

          {userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN && (
            <Row gutter={12}>
              {cardData?.map((item, index) => (
                <Col span={8} key={index}>
                  <GetClipBoardLayout
                    isClipBoard={
                      item?.title === t("ProfileMenuNames.CopyReferCode")
                        ? true
                        : false
                    }
                  >
                    <Card
                      hoverable
                      style={{ background: colors.whiteSmoke, height: "110px" }}
                      onClick={() => {
                        if (
                          item?.title === t("ProfileMenuNames.CopyReferCode")
                        ) {
                        }
                        if (item?.title === t("Payments")) {
                          setPaymentMethodDialog(true);
                        }
                        item?.path && navigate(item?.path);
                      }}
                    >
                      <Flex align="center" justify="center" vertical gap="1rem">
                        {React.createElement(item?.icon, {
                          style: { fontSize: "30px" },
                        })}
                        <Title level={5} style={{ textAlign: "center" }}>
                          {item?.title}
                        </Title>
                      </Flex>
                    </Card>
                  </GetClipBoardLayout>
                </Col>
              ))}
            </Row>
          )}
          <List
            dataSource={menuGroup}
            renderItem={(item) => (
              <List.Item key={item?.path} style={{ border: "none" }}>
                <List.Item.Meta
                  style={{ alignItems: "center" }}
                  avatar={React.createElement(item?.icon)}
                  title={
                    <Typography.Link
                      onClick={(event) => handleDrawerMenuClick(event, item)}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {item?.label} <RightOutlined />
                    </Typography.Link>
                  }
                />
              </List.Item>
            )}
          />
        </Flex>
      </AntdDrawer>
      <LanguagePickerDialog
        open={openLanguagePickerDialog}
        onClose={() => {
          setOpenLanguagePickerDialog(false);
        }}
      />

      <PaymentMethodDialog
        open={openPaymentMethodDialog}
        onClose={() => {
          setPaymentMethodDialog(false);
        }}
      />
    </>
  );
};

export default Drawer;
